import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Card, Form} from 'antd'
import Request, {API_URL} from '../../../request'
import moment from 'moment'


@Form.create()

class ShowAllSuggestions extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    suggestions: [],
  }

  apiRequest = async() => {
    let params = {
      results: 1000,
      suggestionType: 'Only Suggestion'
    };
    let response = await Request.getAllSuggestions(params);
    this.setState({total: response.total, suggestions: response.data})
  }
  componentWillMount() {    
  }

  async componentDidMount() {
    await this.apiRequest();
  }

  render() {
    // const {
    //   form: {getFieldDecorator, setFieldsValue}
    // } = this.props
    const {suggestions, total} = this.state;
    return (
      <PageHeaderWrapper title={` Suggestions: ${total} `}>
        <Card bordered={true}>
          <div className="leaderboard">
            <main className="leaderboard__profiles">
              {
                suggestions && suggestions.map((suggestion, index) => {
                  return(
                    <article key={index} className="leaderboard__profile">
                      <span className="leaderboard__name">{suggestion.title}</span>
                      <small><b>BY: </b>{suggestion.createdByUser.name} / {moment(suggestion.createdByUser.time).format('lll')}</small>
                      <p className="faq-desc" dangerouslySetInnerHTML={{__html: suggestion.description}}></p>
                      {
                        suggestion.document && suggestion.document.length ? 
                        <p><a target={'_blank'} href={API_URL+suggestion.document[0].url}>View Document</a></p>
                        :null
                      }
                    </article>)
                })
              }
            </main>
          </div>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default ShowAllSuggestions
